import { displayToast, initializeModals, sendAppsignalError } from "../modules/utils";

class PaymentPage {
  constructor(node) {
    this.element = node;

    this.contentWrappers = this.element.querySelectorAll(".js-content-wrapper");
    this.summaryWrapper = this.element.querySelector(".js-summary-wrapper");

    this.fetchUrl = new URL(this.element.dataset.fetchUrl, window.location);
    this.shortSummaryUrl = new URL(this.element.dataset.shortSummaryUrl, window.location);

    this.initialize();
  }

  addEventListeners() {
    this.addressSelectTags.forEach((addressSelectTag) => {
      addressSelectTag.addEventListener("change", (e) => {
        const { target } = e;
        const { name, value } = target;

        if (value === "0") {
          return;
        }

        this.fetchUrl.searchParams.set(name, value);
        this.fetchContent();
      });
    });

    this.paymentWrappers.forEach((paymentWrapper) => {
      paymentWrapper.addEventListener(
        "ajax:post",
        (e) => {
          this.contentWrappers.forEach((contentWrapper) => {
            contentWrapper.classList.add("is-loading");
          });

          this.handleAjaxResponse(e.detail);
          this.initialize();
        },
        {
          once: true,
        }
      );
    });

    this.shipmentOptions.forEach((radioButton) => {
      radioButton.addEventListener("change", () => {
        const { name, value } = radioButton;

        this.shortSummaryUrl.searchParams.set(name, value);
        this.fetchShortSummary();
      });
    });

    this.paymentOptions.forEach((radioButton) => {
      radioButton.addEventListener("change", () => {
        const { name, value } = radioButton;

        this.shortSummaryUrl.searchParams.set(name, value);
        this.fetchShortSummary();
      });
    });

    this.deliveryCollapses.forEach((collapse) => {
      const inputs = collapse.querySelectorAll("input");

      collapse.addEventListener("show.bs.collapse", () => {
        inputs.forEach((input) => {
          input.disabled = false;
        });
      });

      collapse.addEventListener("hide.bs.collapse", () => {
        inputs.forEach((input) => {
          input.disabled = true;
        });
      });
    });
  }

  reinitializeVariables() {
    // These should be reinitialized after the ajax:post event since the DOM has changed

    this.addressSelectTags = this.element.querySelectorAll(".js-address-select");
    this.shipmentOptions = this.element.querySelectorAll(".js-radio-button");
    this.paymentOptions = this.element.querySelectorAll(".js-payment-radio-button");
    this.paymentWrappers = this.element.querySelectorAll(".js-payment-wrapper");
    this.summaryProductsWrapper = this.element.querySelector(".js-summary-products");
    this.priceIncludingDiscountElement = this.element.querySelector(".js-price-including-discount");
    this.totalPriceIncludingVatElement = this.element.querySelector(".js-price-including-vat");
    this.paymentPriceElement = this.element.querySelector(".js-payment-price");
    this.paymentTextElement = this.element.querySelector(".js-payment-text");
    this.qvPointsElement = this.element.querySelector(".js-qv-points");
    this.deliveryCollapses = this.element.querySelectorAll(".js-delivery-collapse");

    this.shipmentTextElement = this.element.querySelector(".js-shipment-text");
    this.shipmentPriceElement = this.element.querySelector(".js-shipment-price");
    this.freeShippingWrapper = this.element.querySelector(".js-free-shipping-wrapper");
  }

  initialize() {
    this.reinitializeVariables();
    this.addEventListeners();
  }

  fetchContent() {
    this.contentWrappers.forEach((contentWrapper) => {
      contentWrapper.classList.add("is-loading");
    });

    fetch(this.fetchUrl, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((response) => {
        this.response = response;

        if (response.status == 200) {
          return response.json();
        }

        throw new Error("Content fetch failed");
      })
      .then((data) => {
        this.handleAjaxResponse(data);
        this.initialize();
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorFetch);
        sendAppsignalError(e, "PaymentPage", {
          response: this.response,
        });
      });
  }

  handleAjaxResponse(data) {
    const { shipmentContent, summary, paymentMethods, termsAndConditions } = data;

    const contentArray = [shipmentContent, paymentMethods, termsAndConditions, summary];

    this.contentWrappers.forEach((contentWrapper, index) => {
      if (typeof contentArray[index] === "object") {
        this.updateSummary(contentArray[index]);
      } else {
        contentWrapper.innerHTML = contentArray[index];
      }
      window.Beyuna.initClasses(contentWrapper);
      initializeModals(contentWrapper);

      document.body.classList.remove("show-collapsible-content");
      contentWrapper.classList.remove("is-loading");
    });
  }

  fetchShortSummary() {
    this.summaryWrapper.classList.add("is-loading");

    fetch(this.shortSummaryUrl, {
      retries: 3,
      retryDelay: 1000,
    })
      .then((response) => {
        this.response = response;

        if (response.status == 200) {
          return response.json();
        }

        throw new Error("Short summary fetch failed");
      })
      .then((data) => {
        const { summary } = data;

        if (summary === undefined) {
          return;
        }

        this.updateSummary(summary);
      })
      .catch((e) => {
        console.error(e);
        displayToast(this.element.dataset.errorFetch);
        sendAppsignalError(e, "PaymentPage", {
          response: this.response,
        });
      })
      .finally(() => {
        this.summaryWrapper.classList.remove("is-loading");
      });
  }

  updateSummary(summary) {
    const { products, priceIncludingDiscount, shipment, totalPriceIncludingVat, qvPoints, payment } = summary;

    this.summaryProductsWrapper.innerHTML = "";

    products.forEach((product) => {
      this.summaryProductsWrapper.innerHTML += product;
    });

    this.priceIncludingDiscountElement.innerHTML = priceIncludingDiscount;
    this.totalPriceIncludingVatElement.innerHTML = totalPriceIncludingVat;

    if (payment) {
      this.paymentPriceElement.innerHTML = payment.paymentPrice;
      this.paymentTextElement.innerHTML = payment.paymentText;
    }

    this.qvPointsElement.innerHTML = qvPoints;

    const { shipmentText, shipmentPrice, freeShippingElement } = shipment;

    this.shipmentTextElement.innerHTML = shipmentText;
    this.shipmentPriceElement.innerHTML = shipmentPrice;
    this.freeShippingWrapper.innerHTML = freeShippingElement;
  }
}

const payment = document.querySelector("[ data-js='payment']");

if (payment) {
  new PaymentPage(payment);
}
